"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const Tag_1 = require("@Components/Tag");
const get_date_iso_6801_1 = require("@App/helpers/get-date-iso-6801");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const navigation_1 = __importDefault(require("@App/navigation"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const contexts_1 = require("@App/contexts");
class WorkItemSimple extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "work", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setWorkToDraft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.context.workStore.setWorkDraftToLocal(this.work);
            }
        });
        Object.defineProperty(this, "setLocalIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const work = this.props.data;
                this.work = Object.assign(Object.assign({}, work), { alternativeTitles: work.alternativeTitles
                        ? work.alternativeTitles.map((at, indexAT) => (Object.assign(Object.assign({}, at), { localId: indexAT + 1 })))
                        : [], originalPublishers: work.originalPublishers
                        ? work.originalPublishers.map((op, indexOP) => (Object.assign(Object.assign({}, op), { localId: indexOP + 1, administratorPublishers: op.administratorPublishers
                                ? op.administratorPublishers.map((ap, indexAP) => (Object.assign(Object.assign({}, ap), { localId: indexAP + 1 })))
                                : [], writers: op.writers
                                ? op.writers.map((writer, indexWR) => (Object.assign(Object.assign({}, writer), { localId: indexWR + 1 })))
                                : [] })))
                        : [], writers: work.writers
                        ? work.writers.map((writer, indexWR) => (Object.assign(Object.assign({}, writer), { localId: indexWR + 1 })))
                        : [], recordings: work.recordings
                        ? work.recordings.map((recording, indexRES) => (Object.assign(Object.assign({}, recording), { localId: indexRES + 1 })))
                        : [] });
            }
        });
        (0, mobx_1.makeObservable)(this, {
            work: mobx_1.observable,
            setLocalIds: mobx_1.action,
        });
    }
    componentDidMount() {
        this.setLocalIds();
    }
    render() {
        if (!this.work) {
            return null;
        }
        const { title, updateDate, rightsholderProprietaryId, iswc, isComplete, // isComplete === !typeDraft
        originalPublishers, writers, recordings, registrationHistoryIndicator, songCode, oldDerivative, preTerminationEndDate, } = this.work;
        const { valid, rightsHolderId, disableView } = this.props;
        let totalKnownShares = this.props.data.totalKnownShares;
        totalKnownShares = totalKnownShares ? Math.round(totalKnownShares * 100) / 100 : 0;
        let allPublishersCount = originalPublishers.length;
        originalPublishers.length &&
            originalPublishers.forEach((op) => {
                allPublishersCount += op.administratorPublishers.length;
            });
        return (react_1.default.createElement("div", { className: `work-item-simple-component ${valid ? 'valid' : 'invalid'}` },
            react_1.default.createElement("div", { className: `item-head` },
                react_1.default.createElement("div", { className: 'title-view' },
                    react_1.default.createElement("div", { className: 'title' },
                        react_1.default.createElement("div", { className: 'name-block' },
                            react_1.default.createElement("h5", { className: 'name', title: title }, title),
                            !!oldDerivative && (react_1.default.createElement(Tag_1.TagComponent, { type: oldDerivative ? 'old-derivative' : 'new-derivative', name: oldDerivative ? 'Old Derivative' : 'New Derivative' })))),
                    react_1.default.createElement("div", { className: 'right' },
                        react_1.default.createElement("span", { className: `status small ${valid ? 'valid' : 'invalid'}` }, valid ? 'Ready' : 'Error'),
                        !disableView && (react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.rightholder.createWork.bulk.edit.root(rightsHolderId), className: 'link bold', onClick: this.setWorkToDraft, onMouseDown: () => { } }, valid ? 'View' : 'Resolve Errors')))),
                isComplete && registrationHistoryIndicator && (react_1.default.createElement("div", { className: 'tags' },
                    react_1.default.createElement(Tag_1.TagComponent, { type: registrationHistoryIndicator, name: registrationHistoryIndicator }))),
                react_1.default.createElement("div", { className: 'head-sub-info' },
                    songCode && (react_1.default.createElement("p", { className: 'small-2' },
                        react_1.default.createElement("span", null, "MLC Song Code:\u00A0"),
                        react_1.default.createElement("span", { className: 'bold' }, songCode))),
                    iswc && (react_1.default.createElement("p", { className: 'small-2' },
                        react_1.default.createElement("span", null, "ISWC:\u00A0"),
                        react_1.default.createElement("span", { className: 'bold' }, iswc))),
                    updateDate && (react_1.default.createElement("p", { className: 'small-2' },
                        react_1.default.createElement("span", null, "Date:\u00A0"),
                        react_1.default.createElement("span", { className: 'bold' }, (0, get_date_iso_6801_1.getDateFromIso)(updateDate)))),
                    rightsholderProprietaryId && (react_1.default.createElement("p", { className: 'small-2' },
                        react_1.default.createElement("span", null, "Member's Song ID:\u00A0"),
                        react_1.default.createElement("span", { className: 'bold' }, rightsholderProprietaryId))),
                    totalKnownShares ? (react_1.default.createElement("p", { className: 'small-2' },
                        react_1.default.createElement("span", null, "Total known shares:\u00A0"),
                        react_1.default.createElement(react_1.default.Fragment, null, totalKnownShares < 100 ? (react_1.default.createElement("span", { className: 'line' },
                            react_1.default.createElement("span", { className: 'bold' },
                                totalKnownShares,
                                "%\u00A0"),
                            react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'Part of these shares are unknown, so total is less than 100%' }))) : (react_1.default.createElement("span", { className: 'bold' },
                            totalKnownShares,
                            "%"))))) : null,
                    oldDerivative && preTerminationEndDate ? (react_1.default.createElement("p", { className: 'small-2' },
                        react_1.default.createElement("span", null, "Pre Termination End Date:\u00A0"),
                        react_1.default.createElement("strong", null, (0, get_date_iso_6801_1.getDateFromIso)(preTerminationEndDate)))) : null,
                    !oldDerivative && preTerminationEndDate ? (react_1.default.createElement("p", { className: 'small-2' },
                        react_1.default.createElement("span", null, "Post Termination Start Date:\u00A0"),
                        react_1.default.createElement("strong", null, (0, get_date_iso_6801_1.getDateFromIso)(preTerminationEndDate)))) : null)),
            react_1.default.createElement("div", { className: 'item-sub-info' },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", { className: 'small-2' },
                        "Writer (",
                        writers && writers.length ? writers.length : 0,
                        ")"),
                    writers && writers.length ? (react_1.default.createElement("p", { className: 'small-2 bold' },
                        writers[0].firstName,
                        " ",
                        writers[0].lastName)) : null),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", { className: 'small-2' },
                        "Publishers (",
                        allPublishersCount,
                        ")"),
                    originalPublishers && originalPublishers.length ? (react_1.default.createElement("p", { className: 'small-2 bold' }, originalPublishers[0].publisherName)) : null),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", { className: 'small-2' },
                        "Recordings (",
                        recordings && recordings.length ? recordings.length : 0,
                        ")"),
                    recordings && recordings.length ? (react_1.default.createElement("p", { className: 'small-2 bold' }, recordings[0].title)) : null),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", { className: 'small-2' },
                        "Artists (",
                        recordings && recordings.length ? recordings.length : 0,
                        ")"),
                    recordings && recordings.length ? (react_1.default.createElement("p", { className: 'small-2 bold' }, recordings[0].artistName)) : null))));
    }
}
exports.default = (0, mobx_react_1.observer)(WorkItemSimple);
WorkItemSimple.contextType = contexts_1.StoresContext;
